import styled from "styled-components"
import { colors } from "../../../../../lib/colors"
import {
  tabletSmallText,
  tabletXlText,
} from "../../../../../media_queries/TabletMediaQueries"

export const InputBox = styled.div<{ focus?: boolean }>`
  background: ${({ focus }) =>
    focus ? "rgba(28,30,36, 0.8)" : " rgba(28,30,36, 0.6)"};
  box-shadow: inset 0px -2.01896px 0px ${({ focus }) => (focus ? "transparent" : "#292933")};
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  padding: 0 0 0 10px;
  transition: all 0.3s;
  position: relative;
  height: 46px;

  input {
    -webkit-appearance: none;
    background: none;
    outline: none;
    border: none;
    font-size: 20px;
    ${tabletXlText}

    color: white;
    line-height: 1.1;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    height: 20px;
    @supports (-webkit-hyphens: none) {
      transform: translateY(-5px);
      height: auto;
    }
    &::placeholder {
      color: white;
      opacity: 1;
    }
  }
  label {
    text-transform: uppercase;
    text-align: left;
    padding: 4px 0 2px;
    user-select: none;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 100%;
    ${tabletSmallText}
  }
`

export const InputWrapper = styled.div<{ focus?: boolean; disabled: boolean }>`
  display: flex;
  transform: ${({ focus }) => (focus ? " scale(0.9) " : "scale(1)")};
  transition: transform 0.3s;
  transform-origin: left;
  opacity: ${({ disabled }) => (disabled ? "0.5" : "1")};
  pointer-events: ${({ disabled }) => (disabled ? "none" : "")};
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "")};
`
export const Currency = styled.div`
  line-height: 0 !important;
  margin-top: 10px;
  font-size: 20px;
  ${tabletXlText}
  @supports (-webkit-hyphens: none) {
    transform: translateY(-3px);
    height: auto;
  }
  @media (min-width: 768px) {
    line-height: 0 !important;
  }

  color: #ffffff;
`
